import React from "react";
import { Select } from "antd";

const { Option } = Select;

const FiltroSelect = ({ value, onChange, options, placeholder }) => (
    <Select value={value} className="filtro-selects" onChange={onChange} placeholder={placeholder} disabled={!options.length} allowClear>
        {options.map(opt => (
            <Option value={opt.id} key={opt.id}>
                {opt.nome}
            </Option>
        ))}
    </Select>
);

export default FiltroSelect;
